import React from 'react';

const NotFound = () => {
  return (
    <div className='not-found'>
      <div className='not-found-text'>Not found!</div>
    </div>
  );
};

export default NotFound;
